import { Routes } from '@angular/router';

export const routes: Routes = [
  // Login Page
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login-page/login-page.module').then((m) => m.LoginPageModule),
  },
  // Dashboard
  // Device Dashboard
  {
    path: 'device-dashboard',
    loadChildren: () =>
      import('./device-dashboard-page/device-dashboard-page.module').then(
        (m) => m.DeviceDashboardPageModule
      ),
  },
  {
    path: 'device-details',
    loadChildren: () =>
      import('./device-details-page/device-details-page.module').then(
        (m) => m.DeviceDetailsPageModule
      ),
  },
  {
    path: 'manual-fota',
    loadChildren: () =>
      import('./manual-fota/manual-fota.module').then(
        (m) => m.DeviceManualFotaPageModule
      ),
  },
  {
    path: 'manual-ota',
    loadChildren: () =>
      import('./manual-ota/manual-ota.module').then(
        (m) => m.DeviceManualOtaPageModule
      ),
  },
  // Ticket Dashboard
  {
    path: 'ticket-dashboard-page',
    loadChildren: () =>
      import('./ticket-dashboard-page/ticket-dashboard-page.module').then(
        (m) => m.TicketDashboardPageModule
      ),
  },

  // Device Utility
  // My Tickets
  {
    path: 'ais140-ticket-list',
    loadChildren: () =>
      import('./ais140-ticket-list/ais140-ticket-list.module').then(
        (m) => m.AIS140TicketListModule
      ),
  },
  {
    path: 'ais140-ticket-details-page',
    loadChildren: () =>
      import('./ais140-ticket-details/ais140-ticket-details.module').then(
        (m) => m.AIS140TicketDetailsPageModule
      ),
  },
  {
    path: 'institutional-sales',
    loadChildren: () =>
      import('./institutional-sales/institutional-sales.module').then(
        (m) => m.InstitutionalSalesPageModule
      ),
  },
  // Dealer Master
  {
    path: 'dealer-master',
    loadChildren: () =>
      import('./dealer-master/dealer-master.module').then(
        (m) => m.DealerMasterModule
      ),
  },
  // Government Server
  {
    path: 'govt-servers-page',
    loadChildren: () =>
      import('./govt-servers-page/govt-servers-page.module').then(
        (m) => m.GovtServersPageModule
      ),
  },
  {
    path: 'govt-servers-add-page',
    loadChildren: () =>
      import('./govt-servers-add-page/govt-servers-add-page.module').then(
        (m) => m.GovtServersAddPageModule
      ),
  },
  // FOTA
  {
    path: 'fota-batch-details',
    loadChildren: () =>
      import('./fota-batch-details/fota-batch-details.module').then(
        (m) => m.FotaBatchDetailsPageModule
      ),
  },
  {
    path: 'fota-batch-list',
    loadChildren: () =>
      import('./fota-batch-list/fota-batch-list.module').then(
        (m) => m.FotaBatchListPageModule
      ),
  },
  {
    path: 'fota-batch-report',
    loadChildren: () =>
      import('./fota-batch-reports/fota-batch-reports.module').then(
        (m) => m.FotaDeviceDetailsPageModule
      ),
  },

  // OTA
  {
    path: 'ota-batch-create',
    loadChildren: () =>
      import('./ota-batch-create/ota-batch-create.module').then(
        (m) => m.OtaBatchCreatePageModule
      ),
  },
  {
    path: 'Ota-batch-list',
    loadChildren: () =>
      import('./ota-batch-list/ota-batch-list.module').then(
        (m) => m.OtaBatchListPageModule
      ),
  },
  {
    path: 'ota-batch-view',
    loadChildren: () =>
      import('./ota-batch-view/ota-batch-view.module').then(
        (m) => m.OtaBatchViewPageModule
      ),
  },
  {
    path: 'Ota-batch-report',
    loadChildren: () =>
      import('./ota-batch-reports/ota-batch-reports.module').then(
        (m) => m.OtaDeviceDetailsPageModule
      ),
  },
  {
    path: 'ota-master',
    loadChildren: () =>
      import('./ota-master/ota-master.module').then((m) => m.OtaMasterModule),
  },
  // Device Model
  {
    path: 'device-model-list',
    loadChildren: () =>
      import('./device-model-list/device-model-list.module').then(
        (m) => m.DeviceModelListPageModule
      ),
  },
  {
    path: 'device-model-details',
    loadChildren: () =>
      import('./device-model-details/device-model-details.module').then(
        (m) => m.DeviceModelDetailsPageModule
      ),
  },
  // Dispatched Devices
  {
    path: 'dispatch-device-list',
    loadChildren: () =>
      import('./dispatch-device-list/dispatch-device-list.module').then(
        (m) => m.DispatchDeviceListPageModule
      ),
  },
  {
    path: 'dispatch-device-add',
    loadChildren: () =>
      import('./dispatch-device-add/dispatch-device-add.module').then(
        (m) => m.DispatchDeviceAddPageModule
      ),
  },
  // Dealer FOTA
  {
    path: 'dealer-fota-approved-files',
    loadChildren: () =>
      import(
        './dealer-fota-approved-files/dealer-fota-approved-files.module'
      ).then((m) => m.DealerFotaApprovedFilesPageModule),
  },
  {
    path: 'delaer-fota',
    loadChildren: () =>
      import('./dealer-fota/delaer-fota-module').then(
        (m) => m.DealerFotaPageModule
      ),
  },

  // Reports
  // Request Logs
  {
    path: 'ais140-api-req-logs',
    loadChildren: () =>
      import('./ais140-api-req-logs/ais140-api-req-logs.module').then(
        (m) => m.AIS140ApiReqLogsPageModule
      ),
  },
  // Response Logs
  {
    path: 'ais140-api-res-logs',
    loadChildren: () =>
      import('./ais140-api-res-logs/ais140-api-res-logs.module').then(
        (m) => m.AIS140ApiResLogsPageModule
      ),
  },
  // Status Logs
  {
    path: 'ais140-tml-api-logs',
    loadChildren: () =>
      import('./ais140-tml-api-logs/ais140-tml-api-logs.module').then(
        (m) => m.AIS140TmlApiLogsPageModule
      ),
  },
  // Sim Batch Report
  {
    path: 'sim-data-details',
    loadChildren: () =>
      import('./sim-data-details/sim-data-details.module').then(
        (m) => m.SimDataDetailsPageModule
      ),
  },
  {
    path: 'device-state-config',
    loadChildren: () =>
      import('./device-state-config/device-state-config.module').then(
        (m) => m.DeviceStateConfigPageModule
      ),
  },
  {
    path: 'device-vin-config',
    loadChildren: () =>
      import('./device-vin-config/device-vin-config.module').then(
        (m) => m.DeviceVinConfigPageModule
      ),
  },
  {
    path: 'device-system-activity-log',
    loadChildren: () =>
      import(
        './device-system-activity-log/device-system-activity-log.module'
      ).then((m) => m.DeviceSystemActivityLogPageModule),
  },
  // EOL VIN Report
  // {
  //   path: "vehicle-eol-data",
  //   loadChildren: () =>
  //     import("./vehicle-eol-data/vehicle-eol-data.module").then(
  //       (m) => m.VehicleEolDataPageModule
  //     ),
  // },
  // {
  //   path: "vehicle-eol-batch",
  //   loadChildren: () =>
  //     import("./vehicle-eol-batch/vehicle-eol-batch.module").then(
  //       (m) => m.VehicleEolBatchPageModule
  //     ),
  // },

  // User
  // User Management
  {
    path: 'user-management',
    loadChildren: () =>
      import('./user-management/user-management.module').then(
        (m) => m.UserManagementPageModule
      ),
  },
  // User Role
  {
    path: 'role-management',
    loadChildren: () =>
      import('./role-management/role-management.module').then(
        (m) => m.RoleManagementPageModule
      ),
  },

  {
    path: 'group-management',
    loadChildren: () =>
      import('./group-management/group-management.module').then(
        (m) => m.GroupManagementPageModule
      ),
  },

  // User Role
  // Profile
  {
    path: 'profile-page',
    loadChildren: () =>
      import('./profile-page/profile-page.module').then(
        (m) => m.ProfilePageModule
      ),
  },
  // In-valid Page
  { path: '**', redirectTo: '' }, // todo: Page not found
];
